var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFluidity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns-xlink": "http://www.w3.org/1999/xlink",
    "xml-space": "preserve",
    "xmlns-serif": "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Fluidity-wave-2",
    "serif-id": "Fluidity wave 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg",
    transform: "matrix(3.16475,0,0,2.99275,-7.84674,-7.04927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.479,
    y: 2.355,
    width: 161.782,
    height: 171.08,
    style: {
      fill: "#ffb4e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "matrix(0.9671,0,0,0.9671,11,12.1989)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -1.24,
    width: 506.669,
    height: 506.669,
    style: {
      fill: "#2e2e2e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "wave",
    transform: "matrix(1.01266,0,0,1.01339,-3.24151,-2.57443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.513,275.097L222.26,275.821C155.821,314.179 81.885,327.94 11,319.936L11,501L501,501L501,194.317C430.329,186.467 356.634,200.26 290.393,238.505L223.513,275.097Z",
    style: {
      fill: "#ffb4e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "F",
    transform: "matrix(562.5,0,0,562.5,82.9231,481.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.547,-0.633L0.23,-0.633L0.23,-0.386L0.507,-0.386L0.507,-0.314L0.23,-0.314L0.23,-0L0.142,-0L0.142,-0.727L0.558,-0.727L0.558,-0.706L0.547,-0.633Z",
    style: {
      fill: "#ffb4e6",
      fillRule: "nonzero",
      stroke: "#ffb4e6",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "F1",
    "serif-id": "F",
    transform: "matrix(562.5,0,0,562.5,82.9231,469.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.547,-0.633L0.23,-0.633L0.23,-0.386L0.507,-0.386L0.507,-0.314L0.23,-0.314L0.23,-0L0.142,-0L0.142,-0.706L0.558,-0.706L0.547,-0.633Z",
    style: {
      fill: "#2e2e2e",
      fillRule: "nonzero",
      stroke: "#ffb4e6",
      strokeWidth: "0.01px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluidity);
export default __webpack_public_path__ + "static/media/fluidity.09f4c13427dd0bbbb18b7f3e4807c699.svg";
export { ForwardRef as ReactComponent };